
import React, { useEffect, useState } from 'react'
import {Stack, Typography ,Box, Pagination} from '@mui/material'
import ExerciseCard from './ExerciseCard';
import { fetchData,exercisesOptions } from '../utils/fetchData';

const Exercises = ({exercises,setExercises,bodyPart}) => {

  const [currentPage,setCurrentPage]=useState(1);
  const exercisePerPage=9;
  const lastIndex=currentPage*exercisePerPage;
  const firstIndex=currentPage*exercisePerPage-exercisePerPage;
  const currentExercises=exercises.slice(firstIndex,lastIndex);

  const paginate=(e,value)=>{
    setCurrentPage(value);
    window.scrollTo({top:"20%" ,behavior:'smooth'})
  }

  useEffect(()=>{

     const fetchInfo=async() => {
         
         if(bodyPart==='all'){
            const exerciseData=await fetchData('https://exercisedb.p.rapidapi.com/exercises',exercisesOptions);
           setExercises(exerciseData);
         }

         else{
            const exerciseData=await fetchData(`https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`,exercisesOptions);
            setExercises(exerciseData);
         }
        
     }
     fetchInfo();
  },[bodyPart]);

  return (
    <Box id="exercises" mt="50px" p="20px" >
        <Typography variant='h2' mb='43px' center>
             Showing Results
        </Typography>
       <Stack flexWrap="wrap" direction="row" justifyContent="Center" sx={{gap:{lg:'110px', xs:'50px'}}} >
          {currentExercises.map((exercise,index) => <ExerciseCard key={index} exercise={exercise}/>)}
       </Stack>
       <Stack mt="100px" alignItems="center">
           {exercises.length>9 && (
              <Pagination 
              shape="rounded"
              count={Math.ceil(exercises.length/exercisePerPage)}
              page={currentPage}
              onChange={paginate}
              />
           )}
       </Stack>
    </Box>
  )
}

export default Exercises